webpackJsonp([275850137669291],{

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/the-divide-lives-on.ad3c0a05.png";

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeList = __webpack_require__(64);
	
	var _ThemeList2 = _interopRequireDefault(_ThemeList);
	
	var _PageHeader = __webpack_require__(103);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _ThemeNavFooter = __webpack_require__(104);
	
	var _ThemeNavFooter2 = _interopRequireDefault(_ThemeNavFooter);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ShareExhibit = __webpack_require__(85);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	var _caseStudyTwoStates = __webpack_require__(107);
	
	var _caseStudyTwoStates2 = _interopRequireDefault(_caseStudyTwoStates);
	
	var _theDivideLivesOn = __webpack_require__(1347);
	
	var _theDivideLivesOn2 = _interopRequireDefault(_theDivideLivesOn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Theme2Page = function Theme2Page(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(_PageHeader2.default, {
	        data: data.allThemesJson.edges[1].node,
	        img: _theDivideLivesOn2.default
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Geographic disparities persist'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'As previous Commonwealth Fund scorecards have documented, the highest-ranked state generally performs two to three times better overall than the lowest-ranked state.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'It\u2019s a stark reminder that where you live can affect both your ability to access high-quality health care and your prospects for a healthy life. Differences between states are most pronounced for hospital admission rates among children with asthma: Vermont had 11 times fewer admissions per 100,000 children than New York did (22 vs. 243).'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__exhibit section__exhibit__padded section__content__wide' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'exhibit__title__block' },
	              'America\u2019s health care divide'
	            ),
	            _react2.default.createElement(
	              'figure',
	              null,
	              _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-7-web.png'), alt: '' })
	            ),
	            _react2.default.createElement(_ShareExhibit2.default, {
	              exhibit: 'exhibit-07',
	              site: data.site.siteMetadata,
	              social: data.allSocialJson.edges })
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'The magnitude of health care disparities within states varies widely when comparing low- and high-income residents'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'In Alabama, for example, low-income adults are nearly seven times more likely than high-income residents to report skipping needed care because of the cost (33% vs. 5%).'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'In Pennsylvania, the disparity is much narrower (17% vs. 9%). This pattern of disparities in access to care is mirrored in uninsured rates, which reflect differences in state policies such as Medicaid eligibility.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#7' },
	                  '7'
	                )
	              ),
	              ' Income-related disparities are evident across all the ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Scorecard'
	              ),
	              '\u2019s dimensions of health system performance.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'Income-related disparities in health care access differ across states'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-8-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Note: Uninsured (ages 19\u201364): U.S. Census Bureau, 2016 One-Year American Community Surveys. Public Use Micro Sample (ACS PUMS); Cost barriers (age 18 and older): 2016 Behavioral Risk Factor Surveillance System (BRFSS).'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: 2011, 2013, and 2016 Behavioral Risk Factor Surveillance System (BRFSS).'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-08',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__heavy' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What Can Be Done?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Socioeconomic disadvantages are a major contributor to disparities in health care and health outcomes across the country.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#8' },
	                  '8'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'In general, people of color are disproportionately more likely than whites to have lower incomes and to be at risk for health care disparities.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#9' },
	                  '9'
	                )
	              ),
	              ' Measuring disparities in health care can help to raise awareness of the need for action, but this is only a first step toward achieving equal opportunity for health.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#10' },
	                  '10'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What Are States Doing?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Many states are promoting health equity by expanding Medicaid eligibility, engaging in multisector partnerships, increasing health care workforce diversity, promoting standards for culturally appropriate services, and addressing the social determinants of health.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#11' },
	                  '11'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Oregon\u2019s Medicaid Coordinated Care Organizations, for example, demonstrate how state policy can help narrow disparities in access to care by improving how health services are delivered to patients.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#12' },
	                  '12'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__case_study' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'section__content section__content__figure case_study__figure' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case_study__figure__wrapper' },
	              _react2.default.createElement(_caseStudyTwoStates.ReactComponent, null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__limit' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'case_study__label' },
	              'A Closer Look:'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'case_study__title' },
	              'New Hampshire and Maine: Two States Where Medicaid Expansion Is in Flux'
	            ),
	            _react2.default.createElement(_Button2.default, { to: '/case-study/medicaid-expansion-in-flux', text: 'Keep Reading' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ThemeNavFooter2.default, { themes: data.allThemesJson.edges }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '7', style: { counterReset: "item 6" }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '7' },
	              'Henry J. Kaiser Family Foundation, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Where Are States Today? Medicaid and CHIP Eligibility Levels for Children, Pregnant Women, and Adults'
	              ),
	              ' (KFF, Mar. 2018), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.kff.org/medicaid/fact-sheet/where-are-states-today-medicaid-and-chip' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.kff.org/medicaid/fact-sheet/where-are-states-today-medicaid-and-chip'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '8' },
	              'Nancy Adler et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Reaching for a Healthier Life: Facts on Socioeconomic Status and Health in the U.S.'
	              ),
	              ' (John D. and Catherine T. MacArthur Foundation Research Network on Socioeconomic Status and Health, n.d.), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.macses.ucsf.edu/downloads/Reaching_for_a_Healthier_Life.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.macses.ucsf.edu/downloads/Reaching_for_a_Healthier_Life.pdf'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '9' },
	              'Jessica L. Semega, Kayla R. Fontenot, and Melissa A. Kollar, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Income and Poverty in the United States: 2016'
	              ),
	              ' (Current Population Reports, U.S. Government Printing Office, Sept. 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://census.gov/content/dam/Census/library/publications/2017/demo/P60-259.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://census.gov/content/dam/Census/library/publications/2017/demo/P60-259.pdf'
	                )
	              ),
	              '; and Agency for Healthcare Research and Quality, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                '2016 National Healthcare Quality and Disparities Report: Executive Summary'
	              ),
	              ' (U.S. Department of Health and Human Services, July 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.ahrq.gov/research/findings/nhqrdr/nhqdr16/summary.html' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.ahrq.gov/research/findings/nhqrdr/nhqdr16/summary.html'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '10' },
	              'John E. McDonough et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'A State Policy Agenda to Eliminate Racial and Ethnic Disparities'
	              ),
	              ' (The Commonwealth Fund, June 2004), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/programs/minority/mcdonough_statepolicyagenda_746.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/programs/minority/mcdonough_statepolicyagenda_746.pdf'
	                )
	              ),
	              '; and National Partnership for Action to End Health Disparities, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'National Stakeholder Strategy for Achieving Health Equity'
	              ),
	              ' (U.S. Department of Health and Human Services, Office of Minority Health, n.d.), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://minorityhealth.hhs.gov/npa/files/Plans/NSS/CompleteNSS.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://minorityhealth.hhs.gov/npa/files/Plans/NSS/CompleteNSS.pdf'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '11' },
	              'National Conference of State Legislatures, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'State Approaches to Reducing Health Disparities'
	              ),
	              ' (NCSL, June 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.ncsl.org/research/health/state-approaches-to-reducing-health-disparities.aspx' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.ncsl.org/research/health/state-approaches-to-reducing-health-disparities.aspx'
	                )
	              ),
	              '; Association of State and Territorial Health Officials, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Equity Snapshots'
	              ),
	              ' (ASTHO, 2014), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.astho.org/Programs/Health-Equity/Minority-Health-Survey/2014/State-Snapshots/Map/' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.astho.org/Programs/Health-Equity/Minority-Health-Survey/2014/State-Snapshots/Map/'
	                )
	              ),
	              '; and Office of Minority Health, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'National Standards for Culturally and Linguistically Appropriate Services in Health and Health Care: Compendium of State-Sponsored National CLAS Standards Implementation Activities'
	              ),
	              ' (U.S. Department of Health and Human Services, 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.thinkculturalhealth.hhs.gov/assets/pdfs/CLASCompendium.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.thinkculturalhealth.hhs.gov/assets/pdfs/CLASCompendium.pdf'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '12' },
	              'K. John McConnell et al., \u201COregon\u2019s Emphasis on Equity Shows Signs of Early Success for Black and American Indian Medicaid Enrollees,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Affairs'
	              ),
	              ' 37, no. 3 (Mar. 2018): 386\u201393, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.healthaffairs.org/doi/abs/10.1377/hlthaff.2017.1282' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.healthaffairs.org/doi/abs/10.1377/hlthaff.2017.1282'
	                )
	              ),
	              '.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	//  Components
	exports.default = Theme2Page;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-the-divide-lives-on-js-e2189ec6d62f0032f73d.js